import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
function useResizable({ maxWidth, minWidth, initialWidth, direction, mobileFallbackWidth, trackingOffset = 0 }) {
    const [width, setWidth] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(initialWidth);
    const [isDragging, setIsDragging] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const [isMobile, setIsMobile] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(()=>!window.matchMedia("(min-width: 768px)").matches);
    const disableIframePointerEvents = ()=>{
        const iframes = document.querySelectorAll("iframe");
        iframes.forEach((iframe)=>{
            iframe.style.pointerEvents = "none";
        });
    };
    const enableIframePointerEvents = ()=>{
        const iframes = document.querySelectorAll("iframe");
        iframes.forEach((iframe)=>{
            iframe.style.pointerEvents = "auto";
        });
    };
    const handleMouseDown = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((e)=>{
        setIsDragging(true);
        document.body.style.cursor = "ew-resize";
        disableIframePointerEvents();
        e.preventDefault();
    }, []);
    const handleMouseMove = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((e)=>{
        if (!isDragging) return;
        const adjustedX = "right" === direction ? e.clientX - trackingOffset : e.clientX + trackingOffset;
        const newWidth = "left" === direction ? window.innerWidth - adjustedX : adjustedX;
        setWidth(Math.max(minWidth, Math.min(maxWidth, newWidth)));
    }, [
        isDragging,
        maxWidth,
        minWidth,
        direction,
        trackingOffset
    ]);
    const handleMouseUp = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        if (!isDragging) return;
        setIsDragging(false);
        document.body.style.cursor = "default";
        enableIframePointerEvents();
    }, [
        isDragging
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (isDragging) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
            document.documentElement.style.cursor = "ew-resize";
        }
        return ()=>{
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
            document.documentElement.style.cursor = "";
            if (isDragging) enableIframePointerEvents();
        };
    }, [
        isDragging,
        handleMouseMove,
        handleMouseUp
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const mql = window.matchMedia("(min-width: 768px)");
        const handleChange = (e)=>setIsMobile(!e.matches);
        mql.addEventListener("change", handleChange);
        return ()=>mql.removeEventListener("change", handleChange);
    }, []);
    return {
        width: isMobile && mobileFallbackWidth ? mobileFallbackWidth : width,
        isDragging,
        handle: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            className: "absolute top-0 bottom-0 w-1 z-10 cursor-ew-resize md:block hidden",
            style: {
                left: "left" === direction ? "-2px" : void 0,
                right: "right" === direction ? "-2px" : void 0
            },
            onMouseDown: handleMouseDown
        })
    };
}
export { useResizable };
